import { useRef, useState } from "react";
import { apiProducao, type PcfResumo } from "../lib/api";
import { type Usuario } from "../lib/auth";
import { MsgModal } from "../components/MsgModal";
import { Cabecalho, CampoPcf, DadosPcf } from "./ProducaoPcf";

// reabre_pcf (form pcf_etapas) — "Reabertura de PCF".
// Fonte: C:\MOVIDO PARA SERVIDOR\FORMSTEEL\reabre_pcf\Debug\pcf_etapas.prc
//   LostFocus da PCF (L150-181): só CANCELADA/FINALIZADA, senão "PCF Já Aberta!" e limpa ·
//   Enter na PCF -> botão Reabrir (L137-138) · Reabrir (L208-215): situac='ABERTA', sem confirmação ·
//   Limpar (L109-113) · Sair (L124).

export function ReabrePcf({ usuario, onVoltar }: { usuario: Usuario; onVoltar: () => void }) {
  const [p, setP] = useState<PcfResumo | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);
  const [chave, setChave] = useState(0);
  const refReabrir = useRef<HTMLButtonElement>(null);

  function limpar() {
    setP(null);
    setChave((k) => k + 1);
  }

  async function consultar(n: number) {
    const r = await apiProducao.reabreConsultar(n);
    if (r.erro) {
      setErro(r.erro);
      if (r.erro === "PCF Já Aberta!") limpar(); // L174-175 CALL "LIMPAR"
      else setP(null);
      return;
    }
    setP(r);
    setTimeout(() => refReabrir.current?.focus(), 0);
  }

  async function reabrir() {
    if (!p) return;
    const r = await apiProducao.reabrir(p.numpcf);
    if (!r.ok) return setErro(r.mensagem);
    setOk(`PCF ${p.numpcf} reaberta.`);
    limpar();
  }

  return (
    <div className="app">
      <Cabecalho usuario={usuario} titulo="Reabertura de PCF" sub="PCF" onVoltar={onVoltar} />
      <MsgModal texto={erro} tipo="erro" onClose={() => setErro(null)} />
      <MsgModal texto={ok} tipo="ok" onClose={() => setOk(null)} />
      <div className="pcf-form">
        <section className="pcf-sec">
          <div className="pcf-grid">
            <CampoPcf key={chave} onConsultar={(n) => void consultar(n)} />
          </div>
          {p && <DadosPcf p={p} semSituacao />}
        </section>
        <div className="pcf-acoes">
          <button ref={refReabrir} className="btn-acao" disabled={!p} onClick={() => void reabrir()}>
            Reabrir
          </button>
          <button className="btn-secundario" onClick={limpar}>
            Limpar
          </button>
          <span className="spacer" />
          <button className="btn-secundario" onClick={onVoltar}>
            Sair
          </button>
        </div>
      </div>
    </div>
  );
}
